import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import RewardProductList from "../components/RewardProductList";

const RewardProductListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Reward Products List' />

        <RewardProductList />

      </MasterLayout>
    </>
  );
};

export default RewardProductListPage;
